module.exports = __webpack_public_path__ + "img/icon-chevron-left.3288188c.svg";